import { MessageCircle, Plus, Search } from "lucide-react";
import { conversationTitle, roleLabel, timeLabel } from "./chatUtils";

export function ConversationList({ conversations, currentUserId, selectedId, onSelect, onNew }) {
  return (
    <section className="border-r border-[#DCD7CE] bg-[#F8F5EF] min-h-0 flex flex-col" data-testid="chat-conversation-list-section">
      <div className="p-4 border-b border-[#DCD7CE] flex items-center justify-between gap-3">
        <div>
          <div className="font-heading text-lg font-semibold text-[#0B2230]">Mensagens</div>
          <div className="text-xs text-[#5C6B73]">Equipe conectada</div>
        </div>
        <button
          data-testid="chat-new-conversation-button"
          onClick={onNew}
          className="w-9 h-9 rounded-lg bg-[#0B2230] text-white grid place-items-center hover:bg-[#143346] transition-colors"
          aria-label="Nova conversa"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
      <div className="px-4 py-3 border-b border-[#DCD7CE]">
        <div className="flex items-center gap-2 rounded-lg bg-white border border-[#DCD7CE] px-3 py-2 text-[#5C6B73]">
          <Search className="w-4 h-4" />
          <span className="text-xs">Conversas recentes</span>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-2">
        {conversations.length === 0 && (
          <div data-testid="chat-empty-conversations-message" className="p-5 text-sm text-[#5C6B73] text-center">
            Nenhuma conversa ainda.
          </div>
        )}
        {conversations.map((conversation) => {
          const title = conversationTitle(conversation, currentUserId);
          const preview = conversation.last_message?.text || (conversation.last_message?.file_count ? "Arquivo enviado" : "Sem mensagens");
          const active = selectedId === conversation.id;
          const subtitle = conversation.type === "group"
            ? `${conversation.participants?.length || 0} participantes`
            : roleLabel((conversation.participants || []).find((p) => p.id !== currentUserId)?.role);
          return (
            <button
              key={conversation.id}
              data-testid={`chat-conversation-${conversation.id}-button`}
              onClick={() => onSelect(conversation.id)}
              className={`w-full text-left p-3 rounded-lg mb-1 transition-colors ${active ? "bg-white shadow-sm border border-[#DCD7CE]" : "hover:bg-white/70 border border-transparent"}`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-9 h-9 rounded-lg grid place-items-center ${active ? "bg-[#0B2230] text-white" : "bg-[#EBE5DF] text-[#0B2230]"}`}>
                  <MessageCircle className="w-4 h-4" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <div data-testid={`chat-conversation-${conversation.id}-title`} className="font-medium text-sm text-[#0B2230] truncate">{title}</div>
                    <span className="text-[10px] text-[#8C98A0] shrink-0">{timeLabel(conversation.last_message?.created_at)}</span>
                  </div>
                  <div className="text-[11px] text-[#8C98A0] truncate">{subtitle}</div>
                  <div className="flex items-center justify-between gap-2 mt-1">
                    <div className="text-xs text-[#5C6B73] truncate">{preview}</div>
                    {conversation.unread_count > 0 && (
                      <span data-testid={`chat-conversation-${conversation.id}-unread-badge`} className="min-w-5 h-5 px-1 rounded-full bg-[#C2410C] text-white text-[10px] grid place-items-center">
                        {conversation.unread_count}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}